/** @type {import('../schema').ProcessDefinition} */
const amenities = {
  id: "amenities",
  name: "Amenities (reserva y limpieza)",
  category: "operaciones",
  outcome:
    "Reservar espacios comunes por turnos sin choques, generar el cargo que cae en el cierre y disparar la limpieza post-reserva al personal.",
  trigger:
    "El Administrador configura el amenity; el Residente (o el admin) reserva un turno.",
  actors: ["Administrador", "Residente", "Sistema", "Empleado"],
  status: "COMPLETO",
  description:
    "Configuración del amenity (turnos, tarifa, reglas y si requiere limpieza), reserva por el residente con validación de disponibilidad, cargo (amenitycharges) que consume el cierre y, si el amenity requiere limpieza, generación automática de una tarea para el empleado de limpieza vinculada a la reserva.",
  lanes: [
    { id: "admin", actor: "Administrador" },
    { id: "res", actor: "Residente" },
    { id: "sys", actor: "Sistema" },
    { id: "emp", actor: "Empleado" },
  ],
  steps: [
    { id: "s1", laneId: "admin", type: "start", label: "Configura el amenity", description: "Define turnos, tarifa, moneda, reglas (anticipación, máximo de reservas activas) y si requiere limpieza (requiresCleaning + empleado de limpieza).", evidence: "src/screens/admin/AmenityConfig.jsx" },
    { id: "s2", laneId: "admin", type: "task", label: "Bloquea fechas", description: "Bloquea días por mantenimiento o evento (reserva status: blocked).", evidence: "src/screens/admin/ReservasAmenities.jsx:429" },
    { id: "s3", laneId: "res", type: "task", label: "Elige día y turno", description: "Selecciona un día y un turno; el sistema valida las reglas del amenity.", evidence: "src/screens/Amenities.jsx" },
    { id: "s4", laneId: "sys", type: "decision", label: "¿Turno disponible?" },
    { id: "s5", laneId: "res", type: "task", label: "Turno ocupado: se bloquea", description: "Si el turno está ocupado, se impide la doble reserva." },
    { id: "s6", laneId: "sys", type: "document", label: "Confirma la reserva", description: "Crea la reserva (reservas, status: confirmed).", evidence: "src/screens/Amenities.jsx:406" },
    { id: "s7", laneId: "sys", type: "document", label: "Genera el cargo (amenitycharges)", description: "Si el amenity tiene costo, crea el cargo pendiente (status: pending) vinculado a la reserva.", evidence: "src/screens/Amenities.jsx:406" },
    { id: "s8", laneId: "sys", type: "decision", label: "¿Requiere limpieza?", description: "Según el flag requiresCleaning del amenity." },
    { id: "s9", laneId: "sys", type: "notification", label: "Auto-genera la tarea de limpieza", description: "Crea employee_tasks 'Limpieza: {amenity}' (autoGenerated, reservaId, dueDate) para el/los empleado(s) de limpieza, status: pendiente.", evidence: "src/screens/Amenities.jsx:469" },
    { id: "s10", laneId: "emp", type: "task", label: "Ejecuta y completa la limpieza", description: "El empleado trabaja la tarea: pendiente → en_progreso → completada (completedAt).", evidence: "src/screens/employee/TareasEmployee.jsx:74" },
    { id: "s11", laneId: "res", type: "decision", label: "¿Cancela la reserva?" },
    { id: "s12", laneId: "res", type: "task", label: "Cancela la reserva", description: "Reserva → cancelled; reversa el cargo (amenitycharges: reversed) y cancela la tarea de limpieza (employee_tasks: cancelada).", evidence: "src/screens/Amenities.jsx:553" },
    { id: "s13", laneId: "sys", type: "end", label: "Cargo listo para el cierre", description: "El cargo pendiente se bloquea e incluye en el cierre del residente (locked_for_cierre → included_in_cierre).", evidence: "src/utils/cierreApprove.js:69" },
  ],
  transitions: [
    { from: "s1", to: "s2" },
    { from: "s2", to: "s3" },
    { from: "s3", to: "s4" },
    { from: "s4", to: "s6", label: "disponible" },
    { from: "s4", to: "s5", label: "ocupado" },
    { from: "s5", to: "s3" },
    { from: "s6", to: "s7" },
    { from: "s7", to: "s8" },
    { from: "s8", to: "s9", label: "sí" },
    { from: "s8", to: "s11", label: "no" },
    { from: "s9", to: "s10" },
    { from: "s10", to: "s11" },
    { from: "s11", to: "s12", label: "sí" },
    { from: "s11", to: "s13", label: "no" },
    { from: "s12", to: "s13" },
  ],
};

export default amenities;
